import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-marchand',
  templateUrl: './dashboard-marchand.component.html',
  styleUrls: ['./dashboard-marchand.component.css']
})
export class DashboardMarchandComponent {

}
